export enum KeyEventResult {
  handled,
  ignored,
  skipRemainingHandlers,
}
